import ReducerUtils from "../../utils/ReducerUtils"
import Actions from "../../model/constant/actions"

const Deleting = ReducerUtils.createReducer<boolean>(false,{
  [Actions.DELETING_MARKETING_EVENT_ELEMENT] : (state, action) => action.deleting
})

export default Deleting
